import React from "react";

interface StatCardProps {
  title: string;
  value: string | number;
  imgClass: string;
  valueColor?: string;
}

const StatCard: React.FC<StatCardProps> = ({
  title,
  value,
  imgClass,
  valueColor,
}) => (
  <div className="col-xl-3 col-sm-6 col-12">
    <div className="card d-flex">
      <div className="dashboard-card mb-3">
        <div>
          <h2 className="mt-4">{title}</h2>
          <h1
            className={`text-2xl font-semibold text-gray-900 ${
              valueColor || ""
            }`}
          >
            {value}
          </h1>
        </div>
        <div className="flex items-center justify-center size-[50px] rounded-lg dashboard-icon dash-icon mt-4">
          <img src={imgClass}></img>
        </div>
      </div>
    </div>
  </div>
);

export default StatCard;
